/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import videoItem from './modules/video/videoItem';
import videosList from './modules/video/videosList';
import episodeItem from './modules/episode/episodeItem';
import episodesList from './modules/episode/episodesList';
import programItem from './modules/program/programItem';
import programsList from './modules/program/programsList';
import filter from './modules/filter/filter';

import editingCollection from './modules/editingCollection';
import attachment from './modules/attachment';
import gallery from './modules/gallery';
import authToken from './modules/authToken';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    videoItem,
    videosList,
    episodeItem,
    episodesList,
    programItem,
    programsList,
    filter,
    editingCollection,
    attachment,
    gallery,
    authToken,
  },
});
